<template>
	<div>
		<banner :banner="banner" />
	</div>
</template>

<script>
	import banner from '@/components/home/banner';

	function addLogin(value) {
		const index = this.menu.findIndex(m => m.name === 'Login');
		if (index > -1) {
			if (value) {
				this.menu.splice(index, 1);
			}
		} else {
			this.menu.push({ id: 7, name: 'Login', active: false });
		}
	}

	function changeItem(id) {
		this.menu = this.menu.map((item) => {
			const newItem = { ...item };
			newItem.active = item.id === id;
			return newItem;
		});
	}

	function data() {
		return {
			banner: {
				name: 'Banner 1',
				urlImage: '/static/img/banner/banner-1@2x.jpg',
			},
			menu: [
				{ id: 1, name: 'Nosotros', active: true },
				{ id: 2, name: 'Beneficios', active: false },
				{ id: 3, name: 'Clientes', active: false },
				{ id: 4, name: 'Planes', active: false },
				{ id: 5, name: 'Blog', active: false },
				{ id: 6, name: 'Contáctanos', active: false },
			],
		};
	}

	export default {
		name: 'pages-home',
		components: {
			banner,
		},
		data,
		methods: {
			addLogin,
			changeItem,
		},
	};
</script>



// WEBPACK FOOTER //
// src/pages/home/pages-home.vue